import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ProductPlateIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M12 1.25C6.0723 1.25 1.25 6.0723 1.25 12C1.25 17.9277 6.0723 22.75 12 22.75C17.9277 22.75 22.75 17.9277 22.75 12C22.75 6.0723 17.9277 1.25 12 1.25ZM16 11.5C15.0752 11.5 14.5 10.8706 14.5 9.8569C14.5 8.6894 15.2568 7.5 16 7.5C16.7432 7.5 17.5 8.6895 17.5 9.8569C17.5 10.8706 16.9248 11.5 16 11.5ZM16.5 20.0745V12.453C17.6987 12.2345 18.5 11.2295 18.5 9.8569C18.5 8.269 17.4736 6.5 16 6.5C14.5264 6.5 13.5 8.269 13.5 9.8569C13.5 11.2295 14.3013 12.2345 15.5 12.453V20.5575C14.4193 21.0011 13.2387 21.2499 12 21.2499C10.7613 21.2499 9.5807 21.0011 8.5 20.5575V12.4622C9.6542 12.2881 10.5 11.5202 10.5 10.5708C10.5 8.977 10.2539 7.4805 10.2432 7.418C10.1983 7.1455 9.9419 6.9654 9.668 7.0069C9.3955 7.0523 9.2115 7.3096 9.2569 7.5821C9.2593 7.5967 9.5001 9.0626 9.5001 10.5709C9.5001 10.9582 9.0693 11.3048 8.5001 11.4389V7.0001C8.5001 6.7237 8.2765 6.5001 8.0001 6.5001C7.7237 6.5001 7.5001 6.7237 7.5001 7.0001V11.4389C6.9309 11.3048 6.5001 10.9581 6.5001 10.5709C6.5001 9.0626 6.7408 7.5968 6.7433 7.5821C6.7887 7.3096 6.6046 7.0523 6.3322 7.0069C6.0568 6.9644 5.8024 7.1456 5.757 7.418C5.7463 7.4805 5.5002 8.9771 5.5002 10.5708C5.5002 11.5202 6.346 12.2881 7.5002 12.4622V20.0745C4.6701 18.4909 2.7502 15.4671 2.7502 12C2.75 6.8994 6.8994 2.75 12 2.75C17.1006 2.75 21.25 6.8994 21.25 12C21.25 15.4672 19.3301 18.4909 16.5 20.0745Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ProductPlateIcon.displayName = 'ProductPlateIcon';
